import { render, staticRenderFns } from "./Withsend.vue?vue&type=template&id=69c864a4&scoped=true"
import script from "./Withsend.vue?vue&type=script&lang=js"
export * from "./Withsend.vue?vue&type=script&lang=js"
import style0 from "./Withsend.vue?vue&type=style&index=0&id=69c864a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69c864a4",
  null
  
)

export default component.exports